export class BrandModel {
    constructor(public id: number, public name: string) { }
}


// WEBPACK FOOTER //
// ./src/app/shared/brand.model.ts